import { useEffect, useState } from "react";
import { api } from "../../lib/api";

const LOGOS = [
  { id: "visa", label: "Visa", src: "/pay/visa.svg" },
  { id: "mastercard", label: "Mastercard", src: "/pay/mastercard.svg" },
  { id: "amex", label: "American Express", src: "/pay/americanexpress.svg" },
  { id: "cabal", label: "Cabal", text: "CABAL", color: "#0057A6" },
  { id: "modo", label: "MODO", text: "MODO", color: "#00A859" },
];

let cached = null;
/** true cuando el pago con tarjeta (NAVE) está activo. */
export const useCardEnabled = () => {
  const [on, setOn] = useState(Boolean(cached));
  useEffect(() => {
    let alive = true;
    (cached ??= api.get("/payments/config").then((r) => Boolean(r.data?.card_enabled)).catch(() => false))
      .then((v) => { if (alive) setOn(v); });
    return () => { alive = false; };
  }, []);
  return on;
};

/** Logos de los medios de pago aceptados. No muestra nada hasta que el pago con tarjeta esté activo. */
export const PaymentLogos = ({ testid = "payment-logos", className = "" }) => {
  const on = useCardEnabled();
  if (!on) return null;
  return (
    <ul data-testid={testid} aria-label="Medios de pago aceptados" className={`flex flex-wrap items-center gap-2 ${className}`}>
      {LOGOS.map((l) => (
        <li key={l.id} data-testid={`${testid}-${l.id}`} title={l.label} className="grid h-8 w-14 place-items-center rounded-md bg-white px-2 ring-1 ring-black/10">
          {l.src ? <img src={l.src} alt={l.label} className="h-5 w-auto" /> : <span className="text-[11px] font-black tracking-wide" style={{ color: l.color }}>{l.text}</span>}
        </li>
      ))}
    </ul>
  );
};
